import { ReactNode } from "react";

interface AppBadgeProps {
  children: ReactNode;
  fontSize?: number;
  borderRadius?: number;
  lineHeight?: number;
  color?: string;
  backgroundColor?: string;
  className?: string;
}

const AppBadge = ({
  children,
  fontSize = 16,
  borderRadius = 4,
  lineHeight = 1.2,
  color = "#031108",
  backgroundColor = "#e8edea",
  className,
}: AppBadgeProps) => {
  return (
    <div
      className={`${className} font-weight-bold border border-superlight d-inline-block mx-1 p-1`}
      style={{ fontSize, borderRadius, lineHeight, color, backgroundColor }}
    >
      {children}
    </div>
  );
};

export default AppBadge;
